<page-header/>

@if (message) {
  <div class="content-block has-padding" [translate]="message"></div>
}
